module.exports = __webpack_public_path__ + "static/media/famiglia.2bfaf2b6.jpg";